import React, { useEffect, useState } from "react";

// Dependencies
import { Link, useHistory, useLocation } from "react-router-dom";

// NavigationBar
const NavigationBar = ({
  language,
  setLanguage,
  connectWallet,
  walletConnected,
}) => {
  // States
  const history = useHistory();
  const location = useLocation();

  const [activeLink, setActiveLink] = useState("home");
  const [pathname, setPathname] = useState(null);

  const [hamburgerMenuOpened, setHamburgerMenuOpened] = useState(false);

  useEffect(() => {
    setPathname(window.location.pathname);
  }, [location]);

  return (
    <React.Fragment>
      <nav>
        <div className="container">
          <Link
            to="/"
            className="logo"
            onClick={() => {
              setActiveLink("home");
              setHamburgerMenuOpened(false);
            }}
          >
            <img
              src="../../images/brand/logo.webp"
              alt=""
            />
          </Link>

          <button
            className="hamburger-menu-open-trigger"
            onClick={() => {
              setHamburgerMenuOpened(true);
            }}
          >
            <svg
              width="38"
              height="24"
              viewBox="0 0 38 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M31 0H2C0.89543 0 0 0.89543 0 2C0 3.10457 0.89543 4 2 4H31C32.1046 4 33 3.10457 33 2C33 0.89543 32.1046 0 31 0Z"
                fill="#f4aa19"
              ></path>
              <path
                d="M36 10H7C5.89543 10 5 10.8954 5 12C5 13.1046 5.89543 14 7 14H36C37.1046 14 38 13.1046 38 12C38 10.8954 37.1046 10 36 10Z"
                fill="#f4aa19"
              ></path>
              <path
                d="M31 20H2C0.89543 20 0 20.8954 0 22C0 23.1046 0.89543 24 2 24H31C32.1046 24 33 23.1046 33 22C33 20.8954 32.1046 20 31 20Z"
                fill="#f4aa19"
              ></path>
            </svg>
          </button>

          <div
            className={
              hamburgerMenuOpened
                ? "navigation-bar-elements active"
                : "navigation-bar-elements"
            }
          >
            <span
              className="hamburger-menu-close-trigger"
              onClick={() => {
                setHamburgerMenuOpened(false);
              }}
            >
              <svg
                width="26"
                height="26"
                viewBox="0 0 26 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M24.5705 21.8641L4.58075 1.87433C3.81937 1.11295 2.58493 1.11295 1.82354 1.87433C1.06216 2.63571 1.06216 3.87016 1.82354 4.63154L21.8133 24.6213C22.5747 25.3827 23.8091 25.3827 24.5705 24.6213C25.3319 23.8599 25.3319 22.6255 24.5705 21.8641Z"
                  fill="#f4aa19"
                ></path>
                <path
                  d="M21.3684 1.37858L1.3786 21.3683C0.617222 22.1297 0.617222 23.3642 1.3786 24.1256C2.13999 24.8869 3.37443 24.8869 4.13581 24.1256L24.1256 4.13579C24.887 3.37441 24.887 2.13996 24.1256 1.37858C23.3642 0.6172 22.1297 0.6172 21.3684 1.37858Z"
                  fill="#f4aa19"
                ></path>
              </svg>
            </span>

            <ul>
              <li
                className={
                  activeLink === "home" && pathname === "/" ? "active" : null
                }
              >
                <Link
                  to="/"
                  onClick={() => {
                    setActiveLink("home");
                    setHamburgerMenuOpened(!hamburgerMenuOpened);
                  }}
                >
                  Home
                </Link>
              </li>

              <li
                className={
                  activeLink === "about" || pathname === "/about"
                    ? "active"
                    : null
                }
              >
                <Link
                  to="/about"
                  onClick={() => {
                    setActiveLink("about");
                    setHamburgerMenuOpened(!hamburgerMenuOpened);
                  }}
                >
                  About
                </Link>
              </li>

              <li
                className={
                  activeLink === "gallery" || pathname === "/gallery"
                    ? "active"
                    : null
                }
              >
                <Link
                  to="/gallery"
                  onClick={() => {
                    setActiveLink("gallery");
                    setHamburgerMenuOpened(false);
                  }}
                >
                  Gallery
                </Link>
              </li>

              <li
                className={
                  activeLink === "roadmap" || pathname === "/roadmap"
                    ? "active"
                    : null
                }
              >
                <Link
                  to="/roadmap"
                  onClick={() => {
                    setActiveLink("roadmap");
                    setHamburgerMenuOpened(!hamburgerMenuOpened);
                  }}
                >
                  Roadmap
                </Link>
              </li>

              <li
                className={
                  activeLink === "team" || pathname === "/team"
                    ? "active"
                    : null
                }
              >
                <Link
                  to="/team"
                  onClick={() => {
                    setActiveLink("team");
                    setHamburgerMenuOpened(!hamburgerMenuOpened);
                  }}
                >
                  Team
                </Link>
              </li>

              <li
                className={
                  activeLink === "faqs" || pathname === "/faqs"
                    ? "active"
                    : null
                }
              >
                <Link
                  to="/faqs"
                  onClick={() => {
                    setActiveLink("faqs");
                    setHamburgerMenuOpened(false);
                  }}
                >
                  FAQs
                </Link>
              </li>

              <li
                className={
                  activeLink === "mint" || pathname === "/mint"
                    ? "active"
                    : null
                }
              >
                <Link
                  to="/mint"
                  onClick={() => {
                    setActiveLink("mint");
                    setHamburgerMenuOpened(false);
                  }}
                >
                  Mint
                </Link>
              </li>

              {/* <li className="dropdown-menu-parent">
                <Link to="/">Hero NFT Card</Link>

                <div className="dropdown-menu">
                  <div className="dropdown-menu-container">
                    <Link to="/hero-nft-card/about">About</Link>
                    <Link to="/">White List</Link>
                    <Link to="/">Public Minting</Link>
                    <Link to="/hero-nft-card/gallery">Gallery</Link>
                    <Link to="/hero-nft-card/schedule">Schedule</Link>
                    <Link to="/hero-nft-card/faqs">FAQs</Link>
                  </div>
                </div>
              </li> */}
            </ul>

            <button
              onClick={
                walletConnected
                  ? () => {
                      history.push("/my-nfts");
                      setHamburgerMenuOpened(!hamburgerMenuOpened);
                    }
                  : connectWallet
              }
            >
              {walletConnected ? "My NFTs" : "Connect Wallet"}
            </button>

            <div className="languages">
              <div className="active-language">
                <img src={`/images/flag-${language}.webp`} alt="" />
              </div>

              <div className="other-languages">
                <div className="other-languages-container">
                  {language !== "english" && (
                    <img
                      src={`/images/flag-english.webp`}
                      alt=""
                      onClick={() => {
                        setLanguage("english");
                      }}
                    />
                  )}

                  {language !== "korean" && (
                    <img
                      src={`/images/flag-korean.webp`}
                      alt=""
                      onClick={() => {
                        setLanguage("korean");
                      }}
                    />
                  )}

                  {language !== "chinese" && (
                    <img
                      src={`/images/flag-chinese.webp`}
                      alt=""
                      onClick={() => {
                        setLanguage("chinese");
                      }}
                    />
                  )}

                  {language !== "vietnamese" && (
                    <img
                      src={`/images/flag-vietnamese.webp`}
                      alt=""
                      onClick={() => {
                        setLanguage("vietnamese");
                      }}
                    />
                  )}

                  {language !== "arabic" && (
                    <img
                      src={`/images/flag-arabic.webp`}
                      alt=""
                      onClick={() => {
                        setLanguage("arabic");
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </React.Fragment>
  );
};

// Export
export default NavigationBar;
